import { useMutation } from "@tanstack/react-query";
import { completeBookkeepingOAuthApi } from "../api/bookkeepingIntegrationApi";

export const useCompleteBookkeepingOAuthMutation = () => {
  return useMutation({
    mutationFn: ({
      integrationType,
      code,
      state
    }: {
      integrationType: string;
      code: string;
      state: string;
    }) => completeBookkeepingOAuthApi(integrationType, code, state),
  });
};

